<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="inbox-wrapper">
    <b-row class="inbox-wrap flex-fill">
      <b-col
        lg="4"
        md="4"
        sm="12"
        class="left-inbox"
        :class="showList?'sshow':''"
      >
        <!-- Left Inbox -->
        <inbox-list
          ref="inboxes"
          :list-messages="dataInboxList"
          :status-message="dataInboxStatus"
          :open-message="dataInboxOpen"
          @openMessageCall="callMessage"
          @refreshList="insertListData"
          @closeMessageCall="clearMessage"
        />
        <!-- End Left Inbox -->
      </b-col>
      <b-col
        lg="8"
        md="8"
        sm="12"
        class="right-inbox"
        :class="showList?'sshow':''"
      >
        <div
          v-if="dataInboxOpen!==null"
          class="head-msg"
        >
          <div class="msg-head">
            <div class="msg-head-left">
              <div
                class="btn-backs"
                @click="closeMessage()"
              >
                <feather-icon
                  icon="ArrowLeftIcon"
                  size="20"
                />
              </div>
              <span class="avatar">
                <img
                  :src="require('@/assets/images/avatars/admin-small.png')"
                >
              </span>
              <!-- <h4>{{ messageContent.autor }}</h4> -->
              <h4>IOH Support</h4>
            </div>
            <div class="msg-head-right">
              <span>{{ dateFormat(messageContent.time) }}</span>
              <!-- <feather-icon
                icon="TrashIcon"
                class="align-middle"
              /> -->
            </div>
          </div>
          <!-- content message -->
          <vue-perfect-scrollbar
            :settings="settings"
            class="scroll-area"
          >
            <div
              class="msg-content"
              v-html="messageContent.message"
            >
              {{ messageContent.message }}
            </div>
          </vue-perfect-scrollbar>
          <!-- /content message -->
        </div>
        <div v-else>
          <div class="no-msg">
            <img
              id="no message"
              :src="require('@/assets/svg/nomsg.svg')"
              alt="no message"
            >
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import inboxList from './InboxList.vue'

export default {
  components: {
    BRow,
    BCol,
    VuePerfectScrollbar,
    inboxList,
  },
  data() {
    return {
      buttonActive: null,
      openMessage: null,
      showList: false,
      settings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      },
      messageContent: {},
    }
  },
  computed: {
    ...mapGetters('inbox', {
      dataInboxList: 'getInboxList',
      dataInboxStatus: 'getInboxStatus',
      dataInboxOpen: 'getInboxOpen',
    }),
  },
  mounted() {
    this.setDataOpen()
    this.insertListData()
    // else {
    //   console.log('data :', this.dataInboxOpen)
    // }
  },
  methods: {
    // ...mapGetters('inbox', [
    //   'getInboxList',
    //   'getInboxStatus',
    //   'getInboxOpen',
    // ]),
    ...mapActions('inbox', [
      'getInBox',
      'listInbox',
    ]),
    ...mapMutations('inbox', {
      setDataOpen: 'SET_DATA_OPEN',
    }),
    callMessage(id) {
      this.showList = true
      this.openMessage = this.getInboxOpen
      this.messageContent = this.dataInboxList.find(item => item.id === id)
      this.messageContent.message = this.contentMsg(this.messageContent.message)
    },
    closeMessage() {
      this.showList = false
    },
    clearMessage() {
      this.$store.state.inbox.dataInbox.open = null
    },
    dateFormat(t) {
      return this.$refs.inboxes.timeSince(t)
      // let dd = t.replace(/-/g, '/')
      // let setTime = new Date(dd)
      // // let setTime = new Date(t)
      // let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      // let strT = `${setTime.getDate()} ${months[setTime.getMonth()]} ${setTime.getFullYear()} ${setTime.getHours()}:${setTime.getMinutes()}`
      // return strT
    },
    contentMsg(str) {
      // console.log(str.toString())
      // let cs = str.replace(/(\\r\\n|\\n|\\r)/gm, '')
      // console.log(cs)
      return str.replace(/(\\r\\n|\\n|\\r)/gm, '')
    },
    insertListData() {
      this.listInbox().then(() => {
        if (this.dataInboxOpen !== null) {
        // this.messageContent = JSON.parse(JSON.stringify(this.dataInboxList.find(item => item.id === this.dataInboxOpen)))
        // let msg = this.dataInboxList.find(item => item.id === this.dataInboxOpen)
        // console.log(msg, 'psen')
        // this.messageContent = msg.replace(/\r?\n|\r/g, '')
          // this.messageContent = this.dataInboxList.find(item => item.id === this.dataInboxOpen)
          // this.messageContent.message = this.contentMsg(this.messageContent.message)
        }
      })
    },
  },
}
</script>

<style scoped>
.table th, .table td {
padding: 0.2rem !important;
}
.inbox-wrapper{
  height: calc(100vh - 2.5rem);
  padding-bottom: 5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.inbox-wrap{
  background: #EFEFEF;
  border-radius:5px;
  height:100%;
  overflow: hidden;
  -webkit-box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
}
.left-inbox{
  height:100%;
  background: #fff;
  border-right: 1px solid #e0e0e0;
}
.right-inbox{
  background: #efefef;
}
.left-inbox,.right-inbox{
  padding:0;
}
.flex-fill {
    flex:1 1 auto;
}
.msg-head{
  height:62px;
  background: #fff;
  position: relative;
}
.msg-head-left .avatar{
  width:40px;
  height:40px;
  overflow: hidden;
  border-radius:20px;
  position: absolute;
  top: 11px;
  left: 19px;
}
.msg-head-left h4{
  position: absolute;
  font-weight: 1000;
  color: #000;
  top: 21px;
  left: 76px;
}
.btn-backs{
  display: none;
}
@media screen and (max-width: 768px) {
    .right-inbox{
        display: none !important;
    }
    .right-inbox.sshow{
        display: block !important;
    }
    .left-inbox.sshow{
        display: none !important;
    }
    .msg-head-left .avatar{
        left:76px;
    }
   .msg-head-left h4{
       left:129px;
    }
    .btn-backs{
      display: block;
      width: 40px;
      height: 40px;
      border: 1px solid #bebec7;
      border-radius: 20px;
      padding: 9px;
      position: relative;
      top: 10px;
      left: 18px;
    }
}
.msg-search{
  height:62px;
  border-bottom:#EBE9F1 1px solid;
  padding:10px;
}
.msg-content{
  background: #fff;
  border-radius:10px;
  min-height:50vh;
  margin: 10px;
  padding:20px;
  padding-bottom: 4rem;
}
.msg-list-nm{
  position: relative;
  padding:10px;
  border-bottom: 1px solid #EBE9F1;
  min-height:80px;
  cursor: pointer;
}
.msg-list-nmc{
  padding-left:60px;
}
.msg-list-nmc h6, .left-inbox h4{
  font-family: Rubik;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 120%;
  color: #5E5873;
  font-weight: 600;
}
.left-inbox h4{
  font-size: 18px;
    padding: 12px 26px;
    margin: 0;
}
.scroll-area {
  position: relative;
  margin: auto;
  height: calc(100vh - 13rem);
}
.msg-time{
  font-family: Rubik;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: #B9B9C3;
}
.msg-head-right{
    text-align: left;
    position: absolute;
    right: 30px;
    top: 20px;
}
.msg-head-right span{
  color:#B9B9C3;
  margin-right:20px;
}
.msg-head-right svg{
  stroke:rgb(58, 58, 58);
}
.no-msg img{
    width: 24rem;
    top: 30vh;
    left: 20vw;
    position: relative;
}
.no-msg{
  position:relative;
  height:80vh;
}
</style>
